<template>
  <div
    class="d-flex flex-column flex-root"
    :style="{
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      backgroundImage: `url('/images/backgrounds/${backgroundImage}')`,
    }"
  >
    <!--begin::Auth Layout-->
    <div class="login login-3 login-signin-on d-flex flex-row-fluid" id="kt_login">
      <!-- <div class="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid" style="background-image: url('/images/backgrounds/3.jpg');"> -->
      <div class="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid">
        <div class="login-form text-center text-white p-5 position-relative overflow-hidden" style="width: 100%;max-width: 450px;">
          <!--begin::Auth Layout Header-->
          <div class="d-flex flex-center mb-10">
            <a href="#">
              <img src="/images/logo.jpg" class="max-h-100px" alt="" />
            </a>
          </div>
          <!--end::Auth Layout Header-->
          <router-view></router-view>
        </div>
      </div>
    </div>
    <!--end::Auth Layout-->
  </div>
</template>

<script>
export default {
  computed: {
    backgroundImage() {
      // Retorna un entero aleatorio entre min (incluido) y max (excluido)
      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
      }
      return getRandomInt(1, 4) + ".jpg";
    },
  },
  methods: {},
};
</script>

<style>
.auth-container {
  min-height: 100vh;
  background: pink;
}
</style>
